import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-166240bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "侧边栏", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "图标", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "搜索", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "其他", -1))

import { ref, onMounted, reactive } from 'vue';
import {
  RaSelect,
  RaOption,
  RaRadio,
  RaRadioGroup,
  RaCheckbox,
  RaCheckboxGroup,
  RaSlider,
} from '@rafter/pc';
import { settings, showType, sidePosition } from '@/store/settings';

export default /*#__PURE__*/_defineComponent({
  __name: 'CommonConfig',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(RaSelect), {
      modelValue: _unref(settings).sideColumn,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(settings).sideColumn) = $event)),
      placeholder: "Select",
      class: "side-select"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(RaOption), {
          value: _unref(showType).AutoHide,
          label: "自动隐藏"
        }, null, 8, ["value"]),
        _createVNode(_unref(RaOption), {
          value: _unref(showType).AlwaysShow,
          label: "保持显示"
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(RaRadioGroup), {
      modelValue: _unref(settings).sideColumnPosition,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(settings).sideColumnPosition) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(RaRadio), {
          label: _unref(sidePosition).Left
        }, {
          default: _withCtx(() => [
            _createTextVNode("左侧显示")
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_unref(RaRadio), {
          label: _unref(sidePosition).Right
        }, {
          default: _withCtx(() => [
            _createTextVNode("右侧显示")
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _hoisted_3,
    _hoisted_4,
    _createVNode(_unref(RaSelect), {
      modelValue: _unref(settings).newBookmark,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(settings).newBookmark) = $event)),
      placeholder: "Select",
      class: "icon-select"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(RaOption), {
          value: true,
          label: "新标签页打开"
        }),
        _createVNode(_unref(RaOption), {
          value: false,
          label: "当前标签页打开"
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(RaCheckboxGroup), {
      modelValue: _unref(settings).bookmarksConfig,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(settings).bookmarksConfig) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(RaCheckbox), { label: "showIcon" }, {
          default: _withCtx(() => [
            _createTextVNode("显示添加图标")
          ]),
          _: 1
        }),
        _createVNode(_unref(RaCheckbox), { label: "showName" }, {
          default: _withCtx(() => [
            _createTextVNode("显示图标名称")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _hoisted_5,
    _createVNode(_unref(RaSelect), {
      modelValue: _unref(settings).searchOpenNew,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(settings).searchOpenNew) = $event)),
      placeholder: "Select",
      class: "icon-select"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(RaOption), {
          value: true,
          label: "新标签页打开"
        }),
        _createVNode(_unref(RaOption), {
          value: false,
          label: "当前标签页打开"
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(RaCheckboxGroup), {
      modelValue: _unref(settings).searchConfig,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(settings).searchConfig) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(RaCheckbox), { label: "searchSuggestion" }, {
          default: _withCtx(() => [
            _createTextVNode("搜索建议")
          ]),
          _: 1
        }),
        _createVNode(_unref(RaCheckbox), { label: "keepSearchContent" }, {
          default: _withCtx(() => [
            _createTextVNode("保留搜索框内容")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _hoisted_6,
    _createVNode(_unref(RaCheckbox), {
      modelValue: _unref(settings).defaultFont,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(settings).defaultFont) = $event)),
      label: "使用系统默认字体"
    }, null, 8, ["modelValue"])
  ]))
}
}

})